import { Tag } from "./Tag";

export class Iframe extends Tag {

    protected initialize(data: any) {
        if (!data.get("html")) {
            data.set("html", "<iframe width=\"560\" height=\"315\" src=\"" + data.get("src") + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
        }
        super.initialize(data);
    }

    public getTagName(): string {
        return "iframe";
    }
}
